<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('Auth');

export default {
    name: 'EnrollmentChangeChecker',

    computed: {
        ...mapState(['user']),

        echoReady() {
            return !!this.$store.state.Online.$echo;
        },
    },

    watch: {
        echoReady(ready) {
            if (ready) {
                this.$echo
                    .private(`users-${this.user.id}`)
                    .listen('EnrollmentCreated', () => this.$store.commit('SET_OUT_OF_DATE'))
                    .listen('EnrollmentUpdated', () => this.$store.commit('SET_OUT_OF_DATE'))
                    .listen('EnrollmentDeleted', () => this.$store.commit('SET_OUT_OF_DATE'));
            }
        },
    },

    render: () => null,
};
</script>
